import Vue from 'vue'
import App from './App.vue'
import store from './store'
import '@/assets/styles/_global.scss'
import BootstrapVue from 'bootstrap-vue'


// Currently have commented out the bootstrap.css as it was overwriting the base brand styles

import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'animate.css/animate.css'
import aos from 'aos'
import 'aos/dist/aos.css'

aos.init({
  easing: 'ease',
  duration: 1000,
  once: true
});

Vue.config.productionTip = false

Vue.use(BootstrapVue)

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
